import { memo } from 'react';
import { MemberInputTemplate } from 'components/templates/MemberInputTemplate';

type Props = {};

export const MemberInput = memo((_props: Props) => {
	return <MemberInputTemplate />;
});
